<template>
  <div class="rt-approval">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'RtApproval'
};
</script>



// WEBPACK FOOTER //
// rtApproval.vue?88032e54